import { render, staticRenderFns } from "./TabProject.vue?vue&type=template&id=7183c818&"
import script from "./TabProject.vue?vue&type=script&lang=js&"
export * from "./TabProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7183c818')) {
      api.createRecord('7183c818', component.options)
    } else {
      api.reload('7183c818', component.options)
    }
    module.hot.accept("./TabProject.vue?vue&type=template&id=7183c818&", function () {
      api.rerender('7183c818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/talentPortrait/components/tabItem/TabProject.vue"
export default component.exports